import Keycloak, { KeycloakConfig } from "keycloak-js";

type KeycloakRealmConfig = {
    realm: string;
    url: string;
    "ssl-required": string;
    clientId: string;
    "public-client": boolean;
    "confidential-port": number;
};

const KEYCLOAK_URLS = {
    "admin-vb": {
        prod: "https://auth2.virtuabroker.com",
        staging: "https://auth2-stage.virtuabroker.com",
    },
} as const;

export type KeycloakRealm = keyof typeof KEYCLOAK_URLS;

const isStagingEnv = (): boolean => {
    const explicit = process.env.REACT_APP_KEYCLOAK_ENV;
    if (explicit === "prod") return false;
    if (explicit === "stage" || explicit === "staging" || explicit === "dev" || explicit === "test") return true;
    return process.env.NODE_ENV !== "production";
};

export const getKeycloakUrlForRealm = (realm: KeycloakRealm): string => {
    const entry = KEYCLOAK_URLS[realm];
    return isStagingEnv() ? entry.staging : entry.prod;
};

const DEFAULT_CLIENT_ID = "vb-metrics-ui";

const keycloakConfigAdmin: KeycloakRealmConfig = {
    realm: "admin-vb",
    url: getKeycloakUrlForRealm("admin-vb"),
    "ssl-required": "external",
    clientId: DEFAULT_CLIENT_ID,
    "public-client": true,
    "confidential-port": 0,
};

const getKeycloakConfig = (): KeycloakConfig => {
    const baseConfig = keycloakConfigAdmin;
    const baseUrlOverride = process.env.REACT_APP_KEYCLOAK_BASE_URL;
    const clientIdOverride = process.env.REACT_APP_KEYCLOAK_CLIENT_ID;

    const withUrl: KeycloakRealmConfig =
        typeof baseUrlOverride === "string" && baseUrlOverride !== ""
            ? { ...baseConfig, url: baseUrlOverride }
            : baseConfig;

    const finalConfig: KeycloakRealmConfig =
        typeof clientIdOverride === "string" && clientIdOverride !== ""
            ? { ...withUrl, clientId: clientIdOverride }
            : withUrl;

    console.log("getKeycloakConfig - metrics", {
        url: finalConfig.url,
        realm: finalConfig.realm,
        clientId: finalConfig.clientId,
        urlOverridden: typeof baseUrlOverride === "string" && baseUrlOverride !== "",
        clientIdOverridden: typeof clientIdOverride === "string" && clientIdOverride !== "",
    });

    return finalConfig;
};

const instance = new Keycloak(getKeycloakConfig());

export const keycloakClient = {
    instance,
};
